import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import WebDesignPage from './pages/WebDesignPage';
import AIPage from './pages/AIPage';
import MarketingPage from './pages/MarketingPage';
import HostingPage from './pages/HostingPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';
import LeadsAdminPage from './pages/LeadsAdminPage';
import MedSpaPage from './pages/MedSpaPage';
import TattooPage from './pages/TattooPage';
import ConstructionPage from './pages/ConstructionPage';
import OilRigPage from './pages/OilRigPage';
import BacklinksPage from './pages/BacklinksPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CityPage from './pages/CityPage';
import UltimateGuidePage from './pages/UltimateGuidePage';
import ComparisonHub from './pages/ComparisonHub';
import ComparisonPage from './pages/ComparisonPage';
import NotFoundPage from './pages/NotFoundPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => {
    window.scrollTo(0, 0);
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/website-design-guide" element={<UltimateGuidePage />} />
            <Route path="/web-design" element={<WebDesignPage />} />
            <Route path="/web-design-for-med-spas" element={<MedSpaPage />} />
            <Route path="/web-design-for-tattoo-shops" element={<TattooPage />} />
            <Route path="/web-design-for-construction-companies" element={<ConstructionPage />} />
            <Route path="/web-design-for-oil-rig-companies" element={<OilRigPage />} />
            <Route path="/web-design-in-:slug" element={<CityPage />} />
            <Route path="/compare" element={<ComparisonHub />} />
            <Route path="/compare/:slug" element={<ComparisonPage />} />
            <Route path="/ai" element={<AIPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/hosting" element={<HostingPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/backlinks" element={<BacklinksPage />} />
            <Route path="/admin/leads" element={<LeadsAdminPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
